import React, { useEffect } from "react";
import {
  Grid,
  // Card,
  Typography,
  Button,
  // CardActionArea,
  Checkbox,
  Divider,
} from "@material-ui/core";
// import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { FieldValue } from "../../../components/firebase/FirebaseProvider";
import {
  productsCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import Gap from "../../../components/atoms/Gap";
import Header from "../../../components/molecules/Header/WithTitle";
import useStyles from "./style/stylePilih";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
// import InfiniteScroll from "react-infinite-scroll-component";
// import SkeletonProduct from "../../../components/atoms/SkeletonProduct";
// import Divider from "../../../components/Divider";

const LIMIT = 6;
let productsLength = 0;

export default function Pilih() {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const nilai = location?.pathname.split("/");
  const lastVisible = React.useRef();
  const { level, webstoreRef, webstore, promo, global_komisi, preorderUtils } = useData();
  const [loading, setLoading] = React.useState(true);
  const [loadingMore, setLoadingMore] = React.useState(true);
  const [products, setProducts] = React.useState([]);
  const [ids, setIds] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);
  // const [click, setClick] = React.useState(0);
  const matches = useMediaQuery(theme.breakpoints.up("890"));
  const matches1 = useMediaQuery(theme.breakpoints.up("705"));

  useEffect(() => {
    let allProductsLength = Math.max(products.length, ids.length);

    if (productsLength < allProductsLength) {
      productsLength = allProductsLength;
    }
  }, [products, ids]);

  useEffect(() => {
    async function getProducts() {
      setLoading(true);
      setProducts([]);
      // limit 2 products in

      try {
        const query = await productsCollection
          .where("sembunyikan_produk", "==", false)
          .orderBy("created_at", "desc")
          // .limit(LIMIT)
          .get();
        if (!query.empty) {
          const newProducts = await Promise.all(
            query.docs.map(async (product) => {
              const variants = await product.ref
                .collection("variants")
                .where("harga_normal", ">", 0)
                .get();
              return {
                id: product.id,
                ...product.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
            })
          );
          lastVisible.current = query.docs[query.docs.length - 1];

          const filteredProducts = newProducts.filter((product, index) => {
            let hasilSome = webstore?.products?.includes(product.id);
            const checkDownpayment =
              preorderUtils?.down_payment_products?.includes(product.id);
            const downPaymentStatus =
              checkDownpayment && preorderUtils?.down_payment_option;
            return !hasilSome && product.variants.length > 0 && !downPaymentStatus;
          });

          setProducts((products) => [...products, ...filteredProducts]);

          // setProducts(filteredProducts);
          //   loadMoreProducts();
        }
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    }
    getProducts();
  }, [location]);

  const handlePilih = (id) => (e) => {
    const selectedIndex = ids.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(ids, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(ids.slice(1));
    } else if (selectedIndex === ids.length - 1) {
      newSelected = newSelected.concat(ids.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        ids.slice(0, selectedIndex),
        ids.slice(selectedIndex + 1)
      );
    }

    setIds(newSelected);
  };

  const loadMoreProducts = async () => {
    // console.log("jallan");
    if (lastVisible.current && loadingMore) {
      setLoadingMore(true);
      try {
        const query = await productsCollection
          .where("sembunyikan_produk", "==", false)
          .orderBy("created_at", "desc")
          .startAfter(lastVisible.current)
          .limit(LIMIT)
          .get();
        if (!query.empty) {
          const newProducts = await Promise.all(
            query.docs.map(async (product) => {
              const variants = await product.ref
                .collection("variants")
                .where("harga_normal", ">", 0)
                .get();
              return {
                id: product.id,
                ...product.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
            })
          );
          lastVisible.current = query.docs[query.docs.length - 1];

          const filteredProducts = newProducts.filter((product, index) => {
            let hasilSome = webstore?.products?.includes(product.id);
            return !hasilSome && product.variants.length > 0;
          });

          setProducts((products) => [...products, ...filteredProducts]);
        } else {
          // setLoadingMore(false);
          // lastVisible.current = null;
          setLoadingMore(false);
        }
      } catch (e) {
        console.log(e);
        // setLoadingMore(false);
      }
    }
  };

  const handlePilihAll = async () => {
    setSubmitting(true);
    let arr = [];
    products?.map((item) => arr.push(item?.id));
    setIds([...new Set(arr)]);
    setSubmitting(false);
  };

  const handleSave = async () => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    try {
      await webstoreRef.set(
        {
          products: FieldValue.arrayUnion(...ids),
        },
        { merge: true }
      );

      history.goBack();
      enqueueSnackbar("Produk terpilih berhasil ditambahkan ke TokoSaya!", {
        variant: "success",
      });
    } catch (e) {
      console.log(e.message);
      setSubmitting(false);
    }
  };

  const handleBatalAll = () => {
    setIds([]);
  };

  // console.log(products.length);
  return (
    <>
      <Header title="Tambah Produk" back onClick={() => history.goBack()} />
      <Gap height={60} />
      <div
        style={{
          backgroundColor: "#CBD0F9",
          height: 50,
          display: "flex",
        }}
      >
        <h4
          style={{
            padding: 10,
            marginLeft: matches1 ? 30 : 10,
            fontSize: 16,
            fontWeight: "100",
            width: "80%",
            marginTop: 5,
          }}
        >
          {ids.length} produk terpilih
        </h4>
        <div
          style={{
            padding: 26,
            marginTop: -15,
            marginLeft: matches ? -5 : -30,
            paddingRight: 40,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={ids.length > 0 ? handleBatalAll : handlePilihAll}
            style={{ width: matches ? "100%" : "140%", fontSize: 10 }}
            disabled={submitting}
          >
            {submitting === true ? (
              <CircularProgress size={!matches ? 15 : 20} />
            ) : (
              <>{ids.length > 0 ? "Batalkan" : "Pilih Semua"}</>
            )}
          </Button>
        </div>
      </div>
      {/* <InfiniteScroll
        dataLength={products?.length}
        style={{ overflow: "hidden" }}
        next={loadMoreProducts}
        hasMore={loadingMore}
        scrollThreshold
        loader={
          products.length <= 0 ? null : (
            <div
              style={{
                display: "flex",
                width: "100%",
                // height: "100vh",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                // backgroundColor: 'black',
                opacity: 0.4,
                // position: "fixed",
                zIndex: 9999,
                left: 0,
                marginBottom: "2.5%",
                marginTop: "2.5%",
                right: 0,
                bottom: 0,
                top: 0,
              }}
            >
              <CircularProgress />
            </div>
          )
        }
        endMessage={
          <p
            style={{
              textAlign: "center",
              marginBottom: "2.5%",
              marginTop: "2.5%",
            }}
          >
            {products?.length <= 0 ? null : <b>Yay! You have seen it all</b>}
          </p>
        }
      > */}
      {loading ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            // height: "100vh",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: 'black',
            opacity: 0.4,
            // position: "fixed",
            zIndex: 9999,
            // left: 0,
            // marginBottom: "2.5%",
            marginTop: "25%",
            // right: 0,
            // bottom: 0,
            // top: 0,
          }}
        >
          <CircularProgress />
        </div>
      ) : !loading && products.length !== 0 ? (
        <Grid
          container
          className={classes.root}
          style={{ paddingBottom: ids.length > 0 ? "50px" : "0px" }}
        >
          {products.map((item, index) => {
            const stok = item.variants.map((variant) => variant.stok_available);

            const productValue =
              item?.product_value !== undefined &&
              item?.product_value !== "" &&
              !Number.isNaN(item?.product_value) &&
              item?.product_value >= 0
                ? item?.product_value
                : 1;

            const harga = item.variants.map((variant) =>
              calculateHargaLevel(
                variant?.harga_normal,
                global_komisi,
                level?.level,
                productValue
              )
            );

            const harga_normal = item.variants.map(
              (variant) => variant?.harga_normal
            );

            const promoFound = findOnePromo(item, promo);

            const total_stok = stok.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);

            const emptyStock = total_stok === 0 ? true : false;

            const harga_str = arrayToCurrencyString(harga);
            const promoF = promoFound ? true : false;

            const harga_str_promo =
              promoFound &&
              arrayToCurrencyStringPromo(
                harga_normal,
                promoFound,
                level.level,
                global_komisi,
                productValue
              );

            const selected = ids.includes(item.id);

            return (
              <>
                <div
                  style={{
                    width: "100%",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      // marginBottom: "5px",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                  >
                    <Checkbox
                      onClick={handlePilih(item?.id)}
                      color="primary"
                      disabled={submitting}
                      style={{
                        marginRight: "5px",
                        marginLeft: "-15px",
                      }}
                      checked={selected}
                    />
                    <div
                      style={{
                        display: "flex",
                        // marginLeft: "1.5%",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            width: 60,
                            height: 60,
                            marginRight: "10px",
                          }}
                          src={item?.thumbnail?.[0]}
                          alt="logo"
                        />
                      </div>
                      <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              noWrap={true}
                              style={{
                                fontSize: 13,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.nama}
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 13 }}>
                            {harga_str}
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography noWrap style={{ fontSize: 12 }}>
                            stok: {total_stok}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ marginTop: "24px", marginBottom: "24px" }}
                  />
                </div>
              </>
            );
          })}
        </Grid>
      ) : !loading && products.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: "100%",
            padding: "20px",
            textAlign: "center",
            marginTop: "25%",
          }}
        >
          <p>
            <b>Semua Produk Telah Ditambahkan Ke Toko Anda</b>
          </p>
        </div>
      ) : null}
      {/* </InfiniteScroll> */}
      {ids.length > 0 ? (
        <div
          style={{
            position: "fixed",
            backgroundColor: "white",
            bottom: 0,
            maxWidth: "100%",
            width: "960px",
            left: "auto",
            right: "auto",
          }}
        >
          <div
            style={{
              // backgroundColor: "#CBD0F9",
              // padding: "20px",
              paddingRight: "20px",
              paddingLeft: "20px",
              paddingTop: "15px",
              paddingBottom: "10px",
              // height: 50,
              // display: "flex",
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Button
                  style={{ textTransform: "capitalize" }}
                  onClick={handleSave}
                  fullWidth
                  disabled={loading || submitting}
                  color="primary"
                  size="small"
                  variant="contained"
                >
                  {submitting ? (
                    <>
                      <CircularProgress size={20} />
                    </>
                  ) : (
                    <>Simpan</>
                  )}
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      ) : null}
    </>
  );
}
